/**
 * Utility function to check a string is blank.
 *
 * @param str The string
 * @returns {boolean} true if it is blank, false otherwise
 */
export const isBlank = str => ! str || str.trim().length === 0;

/**
 * Utility function to check a string is NOT blank.
 * @param str The string
 * @returns {boolean} true if it is NOT blank, false otherwise
 */
export const isNotBlank = str => ! isBlank(str);

/**
 * Check all the string parameters are blank.
 *
 * @param args The parameters
 * @returns {boolean} true if all blank, false otherwise
 */
export const isAllBlank = (...args) => {
  for (let i = 0; i < args.length; i++){
      if (isNotBlank(args[i])){
          return false;
      }
  }
  return true;
};

/**
 * Check all the string parameters are NOT blank.
 *
 * @param args The parameters
 * @returns {boolean} true if they all are NOT blank, false otherwise
 */
export const isAllNotBlank = (...args) => {
    for (let i = 0; i < args.length; i++){
        if (isBlank(args[i])){
            return false;
        }
    }
    return true;
};

/**
 * Trim the string. If string is null or undefined, return empty string.
 *
 * @param str The string.
 * @returns {*}
 */
export const trimToEmpty = str => str ? str.trim() : "";

/**
 * Check if both strings are the same. It will return true if both strings are blank (i.e., null, undefined, or trimmed to empty).
 *
 * @param str1 first string
 * @param str2 second string
 * @returns {boolean}
 */
export const isSame = (str1, str2) => {
    return (isBlank(str1) && isBlank(str2)) || trimToEmpty(str1) === trimToEmpty(str2);
};